export const BEST_DEALS_VALIDATION = {
    title: {
        required: 'Title wajib diisi',
    },
    product_ids: {
        required: 'Product list wajib diisi',
    },
}
